module.exports = __webpack_public_path__ + "img/google-cloud.b67c2a3e.svg";